export const baseConocimientoFormModel = {
  formId: 'baseConocimientoForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre de la Base',
      errorMsg: 'El nombre es requerido',
    },
    description: {
      name: 'description',
      label: 'Descripción',
    },
    embeddingProvider: {
      name: 'embeddingProvider',
      label: 'Proveedor',
      errorMsg: 'El proveedor es requerido',
    },
    embeddingModel: {
      name: 'embeddingModel',
      label: 'Modelo',
      errorMsg: 'El modelo es requerido',
    },
    file: {
      name: 'file',
      label: 'Archivo de Conocimiento',
      errorMsg: 'El archivo es requerido',
    },
  },
};
